import { useQuery } from '@tanstack/react-query';
import type { GetMainEventListResponse, GetMainOriginalsListResponse } from 'src/store/server/main/new/main.dto';
import { mainService } from 'src/store/server/main/new/main.service';
import type { APICommonResponse } from 'src/types/common.types';

export const USE_MAIN_QUERY_KEY = {
  getMainEventList: 'get-main-event-list',
  getMyPickBrandList: 'get-mypick-brand-list',
  getMainOriginalsList: 'get-main-originals-list',
};

// 메인 이벤트 목록 조회
export const useGetMainEventListQuery = () => {
  return useQuery([USE_MAIN_QUERY_KEY.getMainEventList], () => mainService.getMainEventList(), {
    select: (res: APICommonResponse<GetMainEventListResponse>) => {
      const { data } = res.data;
      return data.map((item) => ({
        idx: item.idx,
        title: item.title,
        subTitle: item.sub_title,
        image: item.image,
        startDateTime: item.start_dttm,
        endDateTime: item.end_dttm,
        linkUrl: item.link_url,
      }));
    },
  });
};

// 메인 오리지널스 목록 조회
export const useGetMainOriginalsListQuery = () => {
  return useQuery([USE_MAIN_QUERY_KEY.getMainOriginalsList], () => mainService.getMainOriginalsList(), {
    select: (res: APICommonResponse<GetMainOriginalsListResponse>) => {
      const { data } = res.data;
      return data.map((item) => ({
        idx: item.idx,
        name: item.name,
        title: item.title,
        subTitle: item.sub_title,
        image: item.image,
        pickName: item.pick_name,
        pickImage: item.pick_image,
        startDateTime: item.start_dttm,
        endDateTime: item.end_dttm,
        linkUrl: item.link_url,
        blankYN: item.blank_yn,
        myFavorite: item.my_favor,
        favoriteDateTime: item.favor_dttm,
      }));
    },
  });
};
